import { ChangeEvent, forwardRef, useMemo, useState } from 'react'
import { useRouter } from 'next/router'

import { InputProps } from '~/bootcamp/Activities/types/activities.types'
import { Breakpoint, useCheckBreakpoint } from '~/utils/useBreakpoint'
import InAppKeyboard from '~/in-app-keyboard/InAppKeyboard'
import useInAppKeyboardLayout from '~/in-app-keyboard/hooks/useInAppKeyboard'
import { resolveInAppKeyboardLayout } from '~/in-app-keyboard/constants/inAppKeyboard.const'
import { AppLanguage } from '~/types/locale'

const MultiInput = forwardRef<HTMLInputElement | null, InputProps>((props, ref) => {
  const { isError, name, onChange, onEnter, value, id, className, autoFocus } = props
  const [isFocused, setIsFocused] = useState(autoFocus ? autoFocus : false)

  const { locale } = useRouter()
  const keyboardLayout = useInAppKeyboardLayout(null)
  const isDesktopKeyboard = useCheckBreakpoint({ gt: Breakpoint.MD })
  const keyboardLayouts = useMemo(
    () => [resolveInAppKeyboardLayout(keyboardLayout, locale as AppLanguage, isDesktopKeyboard)],
    [keyboardLayout, locale, isDesktopKeyboard],
  )

  const style = {
    color: isError ? 'white' : 'purple',
  }

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { value: newValue, name: inputName } = event.target
    onChange(newValue, inputName)
  }

  return (
    <>
      {keyboardLayout ? (
        <InAppKeyboard
          autoFocus={autoFocus ? autoFocus : false}
          className={className}
          focused={isFocused}
          layouts={keyboardLayouts}
          mathFieldClassName={className}
          onChange={(val: string) => onChange(String(val), name)}
          onEnterPress={onEnter ? onEnter : undefined}
          setFocused={setIsFocused}
          style={style}
          type="text"
          value={value}
        />
      ) : (
        <input
          autoFocus={false}
          className={className}
          id={id}
          name={name}
          onChange={handleOnChange}
          onWheel={(event) => event.currentTarget.blur()}
          ref={ref}
          style={style}
          type="text"
          value={value}
        />
      )}
    </>
  )
})

MultiInput.displayName = 'MultiInput'

export default MultiInput
